import React from 'react';

const USDT_SVG = 'https://customer-assets.emergentagent.com/job_invite-earnings-2/artifacts/flf7x5f8_icons8-tether-50.svg';

export function UsdtTrxIcon({ size = 'md' }) {
  const s = {
    sm: { icon: 18, textFont: 12, badgeFont: 9,  badgePad: '1px 5px', gap: 5 },
    md: { icon: 22, textFont: 13, badgeFont: 10, badgePad: '2px 6px', gap: 5 },
    lg: { icon: 28, textFont: 15, badgeFont: 11, badgePad: '2px 8px', gap: 6 },
  }[size] || { icon: 22, textFont: 13, badgeFont: 10, badgePad: '2px 6px', gap: 5 };

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: `${s.gap}px`, flexShrink: 0 }}>
      {/* Tether icon from user-provided SVG */}
      <img
        src={USDT_SVG}
        alt="USDT"
        style={{ width: `${s.icon}px`, height: `${s.icon}px`, objectFit: 'contain', flexShrink: 0 }}
      />

      {/* USDT text */}
      <span style={{
        color: 'white',
        fontWeight: 700,
        fontSize: `${s.textFont}px`,
        fontFamily: 'Outfit, sans-serif',
        letterSpacing: '0.02em',
      }}>USDT</span>

      {/* TRX badge */}
      <div style={{
        background: '#e84040',
        borderRadius: '4px',
        padding: s.badgePad,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <span style={{
          color: 'white',
          fontWeight: 800,
          fontSize: `${s.badgeFont}px`,
          fontFamily: 'Outfit, sans-serif',
          letterSpacing: '0.05em',
        }}>TRX</span>
      </div>
    </div>
  );
}
